<!--
component: ListExamDisp
author: Takumi Ogura
description: 審査処理経過リスト
-->
<template>
	<section class="listExamDisp">
		<v-container fluid class="pt-0 px-0">
			<div class="head-message">{{ headMessage }}</div>
			<v-row class="pt-5 mt-0">
				<v-col>
					<v-card class="pb-3">
						<v-row class="mx-2">
							<v-col>
								<v-data-table
									id="dataTable"
									class="tableView elevation-1"
									:height="$vuetify.breakpoint.height - 250"
									:headers="header"
									:items-per-page="items.length"
									:items="items"
									item-key="shobunId"
									@click:row="clickRow"
									hide-default-footer
									fixed-header
									no-data-text="検索結果はありません。"
									:mobile-breakpoint="0"
								>
								</v-data-table>
							</v-col>
						</v-row>
						<v-row>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="!gaiyoBrowsable" min-width="70%" @click="goBrowseGaiyo()">概要書</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="!kisaiEnable" min-width="70%" @click="goBrowseDaicho()">台帳記載証明</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn :disabled="selectedData == null" min-width="70%" @click="goPlot()">プロット図</v-btn>
							</v-col>
							<v-col align="center" cols="2.3" xs="12" sm="12" md="2">
								<v-btn min-width="70%" @click="downloadCsv()">一覧出力</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<Dialog error :open="errorDialog" :ok="()=>errorDialog=false"
      :title="errorTitle" :body="errorMessage"/>
		<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
		<!-- 検索中ダイアログ -->
		<!--<SearchDialog :flg="searching" msg="検索中" />-->
    <Dialog search :open="searching" :cancel="cancelSearch" :width="dialogBkPoint" title="検索中"/>
		<!-- メッセージダイアログ -->
		<v-dialog id="dialog" :width="dialogBkPoint" v-model="dialogFlg" persistent>
			<v-card>
				<v-card-title>検索</v-card-title>
				<v-card-text class="pa-0">
					<v-row align="center" class="ma-1">
						<v-col cols="2" class="pa-0" align="center">
							<v-icon large color="error" class="ma-auto" v-if="dialogCategory == 1">mdi-alert</v-icon>
							<v-icon large color="warning" class="ma-auto" v-if="dialogCategory == 0">mdi-alert</v-icon>
						</v-col>
						<v-col cols="10" style="white-space:break-spaces;">{{ dialogMsg }}</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pt-1">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogFlg = false" v-if="dialogCategory == 0">いいえ</v-btn>
					<v-btn text color="primary" @click="clickOk()">はい</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
//import SearchDialog from '../components/SearchDialog.vue'
import Dialog from '../components/Dialog.vue'
import { CallApi, callPostApi /*,loadKisai*/ } from '../common/apiAccess'
import { apiUrl } from '../common/utils'
export default {
	name: 'listexamdisp',
	components: {
		//SearchDialog,
		Dialog
	},
	data(){
		return {
      plotVisible: false,
			header: [
				{
					text: '処分ID',
					value: 'shobunId',
					class: "cyan lighten-3 d-none",
					cellClass: 'd-none'
				},
				{
					text: '申請区分',
					value: 'rcpKubun',
					class: "cyan lighten-3"
				},
				{
					text: '受付番号',
					value: 'rcpNo',
					class: "cyan lighten-3"
				},
				{
					text: '受付日',
					value: 'rcpDate',
					class: "cyan lighten-3"
				},
				{
					text: '確認・検査済番号',
					value: 'cnfInsNo',
					class: "cyan lighten-3"
				},
				{
					text: '確認・検査済日',
					value: 'cnfInsDate',
					class: "cyan lighten-3"
				},
				{
					text: '審査状況',
					value: 'examState',
					class: "cyan lighten-3"
				},
				{
					text: '取下げ',
					value: 'drop',
					class: "cyan lighten-3"
				},
				{
					text: '取止め',
					value: 'cancel',
					class: "cyan lighten-3"
				},
				{
					text: '地名地番',
					value: 'placeLotNo',
					class: "cyan lighten-3"
				},
				{
					text: '審査機関',
					value: 'examAuthority',
					class: "cyan lighten-3"
				},
				{
					text: '代表建築主',
					value: 'initRepArchitectName',
					class: "cyan lighten-3"
				},
			],
			items: [],
			selectedData: null, // 選択されている行のデータ格納用
			searching: false,
      // 検索中断用コントローラ
      controller: null,
			// エラー表示フラグ
			dialogFlg: false,
			dialogCategory: 1,
			dialogMsg: '',
			apiData: '',
			// メッセージダイアログ
      authDialog: false,
      errorDialog: false,
      errorTitle: '閲覧不可',
      errorMessage: '閲覧できません。',
		}
	},
	computed:{
		mode: {
			get() { return this.$store.state.mode; },
			set(val) { this.$store.commit('setMode', val); }
		},
		token () {
			return this.$store.state.token;
		},
		unauthorized () {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized () {
			return !this.unauthorized;
		},
		headMessage () {
			return "審査処分経過";
		},
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    kisaiEnable () {
      return this.selectedData && this.selectedData.shubetsu != 1;
    },
    gaiyoBrowsable () {
      return (this.selectedData && this.selectedData.daichoId)
    },
		// ブレークポイント(端末のサイズ・画面サイズ)によって部品のサイズを動的に変える
		dialogBkPoint () {
			switch( this.$vuetify.breakpoint.name) {
				case 'xl':
					return '30%';
				case 'lg':
					return '30%';
				case 'md':
					return '50%';
				case 'sm':
					return '90%';
				case 'xs':
					return '90%';
				default:
					return '30%';
			}
		},
	},
	mounted() {
		if (this.unauthorized) {
			this.authDialog = true;
    }
		this.$store.commit('setCurrentPage', 3);
    this.message = '';

		// DBから取得した値(前画面でstoreに格納済み)をセット
    this.items = this.$store.state.examList;

		// 概要書、台帳記載証明、プロット図いずれかの画面から戻ってきた際の選択行表示処理 DOMの描画を待って実施
		this.$nextTick(function(){
			if(this.$store.state.listExamDispData != null){
				for(let i = 0; i < document.getElementsByTagName('tbody')[0].children.length; i++){
					if(document.getElementsByTagName('tbody')[0].children[i].children[0].innerText == this.$store.state.listExamDispData.shobunId){
						document.getElementsByTagName('tbody')[0].children[i].classList.add('light-blue');
						document.getElementsByTagName('tbody')[0].children[i].classList.add('lighten-4');
					}
				}
				this.selectedData = this.$store.state.listExamDispData;
			}
		});
	},
	// 詳細検索結果リスト画面に戻る際に	審査処分経過リスト画面で選択された行の初期化処理
	beforeRouteLeave(to, from, next) {
		if(to.name === 'list-attr' || to.name === 'menu'){
			this.$store.commit('setListExamDispData', null);
			next();
		}else{
			next();
		}
	},
	methods: {
    cancelSearch() {
      if (this.controller) {
        this.controller.abort();
      }
      this.searching = false;
    },
		// テーブル行が選択された時イベント
		clickRow(data) {
			let bodyTableRow = document.getElementsByTagName('tbody')[0];
			// 色削除
			if(this.selectedData != null){
				if(!(bodyTableRow.getElementsByClassName('light-blue').length == 0 && bodyTableRow.getElementsByClassName('lighten-4').length == 0)){
					bodyTableRow.getElementsByClassName('light-blue')[0].classList.remove('light-blue');
					bodyTableRow.getElementsByClassName('lighten-4')[0].classList.remove('lighten-4');
				}
			}
			// 色付け
			for(let i = 0; i < bodyTableRow.children.length; i++){
				if(bodyTableRow.children[i].children[0].innerText == data.shobunId){
					bodyTableRow.children[i].classList.add('light-blue');
					bodyTableRow.children[i].classList.add('lighten-4');
					this.selectedData = data;
				}
			}
		},
		// TODO: 認証失敗ダイアログ未(401エラー)
		goBrowseGaiyo() {
			this.$store.commit('setListExamDispData',this.selectedData);
      if (this.gaiyoBrowsable) {
        if (!this.selectedData.cnfInsNo || !this.selectedData.cnfInsDate) {
          this.errorMessage = '未処分につき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        else if (this.selectedData.drop) {
          this.errorMessage = '取下げにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        else if (this.selectedData.cancel) {
          this.errorMessage = '取止めにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
				//this.searching = true;
				//const rec = this.items[this.items.indexOf(this.selectedData)];
        const rec = this.selectedData;
        this.$store.commit('setGaiyoId',rec.daichoId);
        this.$store.commit('setUkeDay', rec.rcpDate);
        this.$store.commit('setUkeNo', rec.rcpNo);
				//this.searching = false;
        if (this.selectedData.shubetsu == 1) {
          this.searching = true;
          this.controller = CallApi('Kosaku', `/${this.selectedData.daichoId}`, (data) => {
            this.searching = false;
            if (data.errorCode) {
              console.log(`${data.errorCode}:${data.errorDesc}`);
            }
            else {
              this.$store.commit('setGaiyoData', data);
              this.$router.push('browsekosaku');
            }
          })
          /*
          this.errorMessage = '築造計画概要書は現在、閲覧できません。';
          this.errorDialog = true;
          */
        }
        else {
          this.$router.push({ name: 'loading', params: { action: 4 }});
        }
      }
		},
		goBrowseDaicho() {
			this.$store.commit('setListExamDispData',this.selectedData);
      if (this.selectedData != null) {
        if (!this.selectedData.cnfInsNo || !this.selectedData.cnfInsDate) {
          this.errorMessage = '未処分につき交付できません。';
          this.errorDialog = true;
          return;
        }
        const param = {
          ledgerType: this.selectedData.rcpKubun,
          daichoId: this.selectedData.daichoId,
          kknnNo: this.selectedData.cnfInsNo,
          kknnDay: this.selectedData.cnfInsDate
        };
        const url = apiUrl('KisaiShomeiEx');
				this.searching = true;
        this.controller = callPostApi(url, param, (data) => {
					this.searching = false;
					if(data.errorCode == 401){
						this.authDialog = true;
					}
					else if (data !== null && data.daichoId !== undefined) {
            if(data.cancel || data.drop || data.unBrowsable || data.unDisposed){
              if(data.cancel){
                this.dialogMsg = '取止めにつき交付できません。\n表示しますか？';
                this.dialogCategory = 0;
                this.dialogFlg = true;
              }else if(data.drop){
                this.dialogMsg = '取下げにつき交付できません。\n表示しますか？';
                this.dialogCategory = 0;
                this.dialogFlg = true;
              }else if(data.unBrowsable){
                this.dialogMsg = '閲覧不可につき交付できません。\n表示しますか？';
                this.dialogCategory = 0;
                this.dialogFlg = true;
              }else if(data.unDisposed){
                this.dialogMsg = '未処分につき交付できません。\n表示しますか？';
                this.dialogCategory = 0;
                this.dialogFlg = true;
              }
            }else{
              this.$store.commit('setKisaiData', data);
              this.$router.push('browsedaicho');
            }
          }
          else {
            //ToDo: API呼び出しエラー表示
            console.log(`ListAttr.goBrowseDaicho(): returns ${data}`);
          }
        });
      }
		},
    // プロット図ジャンプ
    goPlot() {
      if (this.selectedData != null) {
        this.$store.commit('setListExamDispData',this.selectedData);
        CallApi('XY', `?uke_no=${this.selectedData.rcpNo}`, (data) => {
          if (data) {
            if (data.errorCode) {
              switch (data.errorCode) {
                case 400:
                  console.log(`error ${data.errorCode}: ${data.errorDesc}`);
                  break;
                case 404:
                  this.errorMessage = '対応する確認プロットが見つかりません。';
                  this.errorDialog = true;
                  break;
                default:
                  console.log(`error ${data.errorCode}: ${data.errorDesc}`);
              }
            }
            else if (data.x) {
              this.$store.commit('setCenter', {x:data.x, y:data.y});
              this.$router.push({ name:'map', params:{targetPlot:data, zoom:19} });
            }
          }
        });
      }
    },
		// 一覧出力処理
		downloadCsv(){
			var headerLine = '\ufeff' + 'No,申請区分,受付番号,受付日,確認・検査済番号,確認・検査済日,審査状況,取下げ,取止め,地名地番,審査機関,代表建築主\n';
			this.items.forEach(function(element, index) {
				var line = (index + 1) + ',' + element['rcpKubun'] + ',' + element['rcpNo'] + ',' + element['rcpDate'] + ',' + element['cnfInsNo'] + ',' + element['cnfInsDate'] + ',' + element['examState'] + ',' +
									element['drop'] + ',' + element['cancel']  + ',' + element['placeLotNo'] + ',' + element['examAuthority'] + ',' + element['initRepArchitectName'] + '\n';
				headerLine += line;
			})
			let blob = new Blob([headerLine],{type: 'text/csv'});
			let link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			let now = new Date();
			link.download = now.getFullYear() + ('0' + (now.getMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2) + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()) + '_審査処分経過一覧.csv';
			link.click();
		},
		// ダイアログクリック処理
		clickOk(){
			this.dialogFlg = false;
			this.$store.commit('setKisaiData', this.apiData);
			this.$router.push('browsedaicho');
		}
	}
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>